export default __webpack_public_path__ + "static/media/Browser_2.cc7c3adc.png";